import { Component, type ReactNode } from 'react';
import { Warning } from '@phosphor-icons/react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-red-50 mb-4">
            <Warning size={28} weight="regular" className="text-red-500" />
          </div>
          <h2 className="text-lg font-bold text-slate-800">Something went wrong</h2>
          <p className="mt-1 text-sm text-slate-500 max-w-md">
            An unexpected error occurred. Try refreshing the page.
          </p>
          {this.state.error && (
            <pre className="mt-4 max-w-lg rounded-lg bg-slate-100 px-4 py-3 text-[11px] text-red-600 font-mono overflow-auto text-left">
              {this.state.error.message}
            </pre>
          )}
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            className="mt-5 rounded-lg bg-slate-900 px-5 py-2 text-[13px] font-semibold text-white shadow-sm hover:bg-slate-800 transition-colors"
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
